<div class="insurance-family family-colored"
     [ngClass]="familySource$ | async"
     [class.lifeislife-badge]="badge">
  <span class="label">{{ label$ | async}}</span>

</div>
